import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';

function Grid({ className, style, classes, children }) {
  return (
    <ul className={classNames(classes.root, className)} style={style}>
      {children}
    </ul>
  );
}

Grid.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
};

Grid.defaultProps = {
  style: null,
  className: null,
  children: null,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'space-around',
    },
  },
});

export default injectSheet(stylesheet)(Grid);



// WEBPACK FOOTER //
// ./src/site-render/src/Grid/Grid.js